import React, { useRef, useState } from 'react';
import { Container, Control as ControlBase, Label, Menu, Option } from './style';
import { Popover } from 'react-tiny-popover';
import { TrashIcon } from './icons';
import { Input } from '@mantine/core';
import { IoIosArrowDown } from 'react-icons/io';

const Control = ControlBase as React.ComponentType<any>;

interface MultipleValuesProps {
  label?: string;
  placeholder?: string;
  values?: string[];
  onAddValue: (value: string | null) => void;
  onRemoveValue: (idx: number) => void;
  isRequired?: boolean;
}

export default function MultipleValues({
  label = 'Multiple(values)',
  placeholder = 'Enter value',
  values = [],
  onAddValue,
  onRemoveValue,
  isRequired = false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ...props
}: MultipleValuesProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string | null>(null);
  const [isFocused, setIsFocused] = useState<boolean>(false);

  const handleAddValue = () => {
    onAddValue(inputValue);
    setInputValue('');
    setIsOpened(true);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && inputValue) {
      handleAddValue();
    }
  };

  const handlePopoverClose = () => {
    setIsOpened(false);
  };

  const handleRemoveValue = (idx: number) => () => {
    onRemoveValue(idx);
  };

  const handleInputFocus = () => {
    setIsFocused(true);
  };

  const handleInputBlur = () => {
    setIsFocused(false);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleTogglePopover = () => {
    setIsOpened(prev => !prev);
  };

  return (
    <Popover
      isOpen={isOpened}
      padding={5}
      onClickOutside={handlePopoverClose}
      positions={['bottom']}
      containerStyle={{ zIndex: '100000' }}
      content={
        <div>
          <Menu>
            {values.length === 0 && (
              <Option>
                <span>No Values</span>
              </Option>
            )}
            {values.map((val, idx) => (
              <Option key={idx}>
                <span>{val}</span> <TrashIcon onClick={handleRemoveValue(idx)} />
              </Option>
            ))}
          </Menu>
        </div>
      }
    >
      <Container ref={ref}>
        <Label>
          {label} {values.length > 0 && `- ${values.length}`}{' '}
          {isRequired && <span style={{ color: 'red' }}>*</span>}
        </Label>
        <Control isFocused={isFocused || isOpened}>
          <Input
            size="xs"
            placeholder={placeholder}
            // @ts-ignore
            value={inputValue}
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            flex="1"
            // @ts-ignore
            width="100%"
          />
          <button onClick={handleTogglePopover}>
            <IoIosArrowDown />
          </button>
        </Control>
      </Container>
    </Popover>
  );
}
